<template>
  <div class="app-activation-info-modal">
    <CustomModal
      :visible="showModal"
      :rowReverse="true"
      title="Mein Modal"
      :showPrev="true"
      :showNext="true"
      prevText="Zurück"
      nextText="Weiter"
      @close="hideModal"
      @prev="keepData"
      @next="collectData"
    >
      <template #header>
        {{ modalTitle }}
      </template>
      <template>
        <slot name="txtActivationInfoModalCollectData">
          <p>Content Text</p>
        </slot>
      </template>
      <template #btnPrevTxt>
        <slot name="txtActivationInfoModalKeepData">Daten behalten</slot>
      </template>
      <template #btnNextTxt>
        <slot name="txtActivationInfoModalRefreshData">Daten löschen und erfassen</slot>
      </template>
    </CustomModal>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import processSteps from '@/mixins/processSteps'
import { stepName as info } from '@/components/process/LIDL/Activation/Info/ActivationInfo.vue'
import { stepName as personal } from '@/components/process/LIDL/Activation/PersonalData/EnterPersonalData.vue'
import CustomModal from '@/components/generic/CustomModal.vue'

export default {
  components: { CustomModal },
  mixins: [processSteps(info, info, personal)],
  props: {
    modalTitle: {
      type: String,
      default: ''
    },
    modalHideFooter: {
      type: Boolean,
      default: false
    },
    modalStatic: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      currentCustomer: {
        activationInfo: false
      }
    }
  },
  computed: {
    showModal: {
      get() {
        return this.$store.getters.viewModal('activationInfo')
      },
      set() {
        // no manual set
      }
    }
  },
  methods: {
    ...mapMutations('activation/info', ['collectActivationData', 'keepActivationData']),
    hideModal() {
      this.$store.commit('changeModalViewState', {
        modal: 'activationInfo',
        viewState: false
      })
    },
    collectData() {
      this.collectActivationData(this.nextStep)
    },
    keepData() {
      this.keepActivationData()
    }
  }
}
</script>
